import React from 'react'
import { useState } from 'react'
import { Outlet, NavLink } from 'react-router-dom'
import { Container, Nav, Navbar, Button } from 'react-bootstrap'

function CustomNav({ logOutBtnHandler }) {
    const [btnClicked, setBtnClicked] = useState(false)

    const logOutHandler = () => {
        if (btnClicked) return
        setBtnClicked(true)
        logOutBtnHandler(true);
        setBtnClicked(false)
    }

    return (
        <>
            <Navbar collapseOnSelect fixed='top' expand='lg' bg='dark' variant='dark'>
                <Container>
                    <Navbar.Brand>MWAN</Navbar.Brand>
                    <Navbar.Toggle aria-controls='responsive-navbar-nav' />
                    <Navbar.Collapse id='responsive-navbar-nav'>
                        <Nav className='me-auto'>
                            <NavLink className='nav-link' to='/'>Add New</NavLink>
                        </Nav>
                        <Nav>
                            <Button disabled={btnClicked} variant='danger' onClick={logOutHandler}>Log Out</Button>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <Container>
                <Outlet />
            </Container>
        </>
    )
}

export default CustomNav